import {
  AccountType,
  OnboardSignupFailEvent,
  type Screen,
  trackEvent,
} from '@otter-ai/telemetry';
import { useCreateUserMutation } from '@/query/mutations/useCreateUserMutation';
import type { CreateUserType } from '@/shared/types/auth';
import { useHandleEmailSignupSuccess } from './useHandleEmailSignupSuccess';

export const useCreateUser = ({
  skipRedirect = false,
  skipHandleSignupSuccess = false,
  screen,
  onSuccess,
  onError,
}: {
  skipRedirect?: boolean;
  skipHandleSignupSuccess?: boolean;
  screen?: Screen;
  onSuccess?: (res: CreateUserType) => void;
  onError?: (error: Error) => void;
}) => {
  const { handleEmailSignupSuccess } = useHandleEmailSignupSuccess({
    screen,
    skipRedirect,
    skipHandleSignupSuccess,
  });

  const {
    mutate: createUser,
    mutateAsync: createUserAsync,
    isPending: isCreatingUser,
  } = useCreateUserMutation({
    onSuccess: async (res) => {
      await handleEmailSignupSuccess(res);

      if (onSuccess) {
        onSuccess(res);
      }
    },
    onError: (error) => {
      trackEvent(
        OnboardSignupFailEvent({
          AccountType: AccountType.email,
          ErrorMessage: error.message,
        }),
      );

      if (onError) {
        onError(error);
      }
    },
  });

  return { createUser, createUserAsync, isCreatingUser };
};
